import {
  configureProductDucks,
  CARD_PRODUCT,
  PERSONAL_SAVINGS_ACCOUNT,
  PERSONAL_CHECKING_ACCOUNT,
  BUSINESS_CHECKING_ACCOUNT,
  KABBAGE_ACCOUNT,
  KABBAGE_BCA,
  KABBAGE_INSIGHTS,
  KABBAGE_LOC,
  KABBAGE_PAYMENTS,
  CROSS_BORDER_PAYMENTS,
  INVESTMENT_ACCOUNT,
  CRYPTO_ACCOUNT,
} from 'axp-product-ducks';
import {
  configureProductDucks as configureProductDucksV1,
} from '@americanexpress/product-ducks';
import updateProductLocale from '../utils/updateProductLocale';
import { B2B_ONEAP, moduleName } from '../constants';

export const productTypes = [
  CARD_PRODUCT,
  PERSONAL_CHECKING_ACCOUNT,
  BUSINESS_CHECKING_ACCOUNT,
  PERSONAL_SAVINGS_ACCOUNT,
  KABBAGE_ACCOUNT,
  KABBAGE_BCA,
  KABBAGE_INSIGHTS,
  KABBAGE_LOC,
  KABBAGE_PAYMENTS,
  CROSS_BORDER_PAYMENTS,
  INVESTMENT_ACCOUNT,
  CRYPTO_ACCOUNT,
  B2B_ONEAP,
];

const getToState = (state) => state.getIn(['modules', moduleName, 'products']);

const memberProducts = () => {
  configureProductDucks({
    getToState,
    defaultTypes: [CARD_PRODUCT],
    filterTypes: productTypes,
    orderTypes: productTypes,
    onLoadProducts: updateProductLocale,
    onAfterSelectProduct: updateProductLocale,
  });

  configureProductDucksV1({
    getToState,
    defaultTypes: [CARD_PRODUCT],
    filterTypes: productTypes,
    orderTypes: productTypes,
    onLoadProducts: updateProductLocale,
    onAfterSelectProduct: updateProductLocale,
  });
};

memberProducts();

export default memberProducts;
